export default __webpack_public_path__ + "static/media/pac.d36042a5.svg";